import { TicketItemStatus, TicketStatus } from '@ancon/wildcat-types'

export default function getTicketItemStatusOfTicketStatus(
  ticketStatus: TicketStatus,
) {
  return <TicketItemStatus>(ticketStatus as number)
}
